import Tippy from '@tippyjs/react/headless';
import React from 'react';
import { followCursor } from 'tippy.js';
import styles from "./DataGridContextMenu.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DataGridContextMenu(props) {
  return /*#__PURE__*/_jsx(Tippy, {
    appendTo: document.body,
    showOnCreate: true,
    offset: [10, 10],
    placement: "auto",
    onClickOutside: props.onClickOutside,
    followCursor: "initial",
    plugins: [followCursor],
    trigger: "click",
    interactive: true,
    render: (attrs, content) => /*#__PURE__*/_jsx("div", {
      className: styles.contextMenuContainer,
      tabIndex: -1,
      ...attrs,
      children: /*#__PURE__*/_jsx("ul", {
        children: props.children
      })
    })
  });
}